<app-page-heading [key]="'nav.hotspot-tracking.map'"
                  [disableMarginBottom]="true" [regions]="regions" [(selectedRegion)]="selectedRegion" (selectedRegionChange)="saveSelectedRegion()">
</app-page-heading>
<div class="col-xs-12 full-height">
    <agm-map [latitude]="lat" [longitude]="lng" [(zoom)]="zoom" (mapDblClick)="dblClickMap($event)"
             [disableDoubleClickZoom]="true" [disableDefaultUI]="true"
             (mapClick)="unselectAddress()" (centerChange)="centerChange($event)">
        <agm-zoom-control></agm-zoom-control>

        <agm-marker *ngIf="hotspot" [latitude]="hotspot.latitude" [longitude]="hotspot.longitude"
                    [markerDraggable]="true"
                    (dragEnd)="openConfirmMoveHotspot(hotspot, $event, confirmMoveModal)" (markerClick)="selectHotspot(hotspot)"
                    [zIndex]="2"
                    [iconUrl]="hotspot.markerSelectedUrl"
        >
            <agm-info-window [isOpen]="true">
                <span *ngIf="hotspot.label"><a class="cmaweb-link" [href]="link.goToHotspot(hotspot.label)" target="_blank">{{hotspot.label}}</a></span>
                <span *ngIf="!hotspot.label"><i>No description yet</i></span>
                <button class="btn btn-sm btn-primary btn-update-label" (click)="openEditHotspot(editModal)">
                    <i class="fa fa-pencil-alt"></i>
                </button>
            </agm-info-window>
        </agm-marker>

        <ng-container *ngFor="let h of hotspots">
            <agm-marker *ngIf="h != hotspot" [latitude]="h.latitude" [longitude]="h.longitude"
                        [markerDraggable]="false" (markerClick)="selectHotspot(h)"
                        [zIndex]="1"
                        [iconUrl]="h.markerNormalUrl"
            >
            </agm-marker>
        </ng-container>

        <agm-marker *ngIf="tempHotspot !== null" [latitude]="tempHotspot.latitude"
                    [longitude]="tempHotspot.longitude"
                    [markerDraggable]="true" (markerClick)="selectTempHotspot(editModal)" [zIndex]="3"
                    (dragEnd)="movetempMarker($event)"
                    [iconUrl]="'/assets/marker-edit.png'"
        >
            <agm-info-window [isOpen]="true" appDisableTrackpadZoom>
                <div class="hotstop-tooltip-info">Click on the marker to create a new hotspot here</div>
            </agm-info-window>
        </agm-marker>

        <agm-circle *ngIf="hotspot !== null && hotspot.id" [latitude]="hotspot.latitude" [longitude]="hotspot.longitude"
                    [fillColor]="'#000000'" [fillOpacity]="0.4" [(radius)]="hotspot.radius">
        </agm-circle>
    </agm-map>

    <div class="address-container">
        <div>
            <div class="address-search-container">
                <div class="address-search">
                    <input class="address-search-input" #searchElement type="text" [(ngModel)]="search"
                           placeholder="Search an address"
                           (keyup)="searchKeyUp($event, confirmMoveModal)">
                    <i class="fa fa-search"></i>
                </div>
                <div class="address-search-result" *ngIf="search !== ''">
                    <div class="address-item" *ngFor="let a of addresses; let i = index"
                         [ngClass]="i == addressActiveIndex ? 'active' : ''"
                         (click)="selectAddress(a, confirmMoveModal)">
                        <i class="fa fa-map-marker"></i>
                        <span class="address-item-description">{{a.description}}</span>
                    </div>
                    <div class="address-item" *ngIf="noResult">
                        <span class="address-item-description">No result</span>
                    </div>
                </div>
            </div>
            <div class="address-selected" *ngIf="hotspot !== null && hotspot.id">
                <span>{{hotspot.address}}</span>
                <i class="fa fa-close" (click)="unselectAddress()"></i>
            </div>
        </div>
        <div class="radius-container" *ngIf="hotspot !== null && hotspot.id">
            <label for="radius-input" class="radius-label">Hotspot radius : {{hotspot.radius}} meters</label>
            <input id="radius-input" type="range" min="10" max="2000" [(ngModel)]="hotspot.radius"
                   (change)="changeRadius()">
        </div>
        <div *ngIf="!infoAlertClosed" class="alert alert-info info-dbl-click">
            <i class="fa fa-info-circle"></i>
            You can create a new hotspot by double clicking on the map or by searching an address
        </div>
    </div>

    <button class="btn btn-secondary back-to-hotspots" (click)="location.back()">
        <span class="fa fa-arrow-left"> </span> Back
    </button>

    <div class="buttons-bottom-right">
        <button class="btn btn-primary" [ngClass]="hotspot === null || !hotspot.id ? 'invisible' : ''"
                (click)="zoomOnHotspot()">
            <i class="fa fa-search-plus"></i> Zoom on Hotspot
        </button>

        <button class="btn btn-info"
                [ngClass]="lat === defaultLat && lng === defaultLng && zoom === defaultZoom ? 'invisible' : ''"
                (click)="resetZoom()">
            <i class="fa fa-search-minus"></i> Reset position
        </button>
    </div>

    <button class="btn btn-danger delete-hotspot" (click)="openConfirmDelete(deleteModal)"
            *ngIf="hotspot !== null && hotspot.id">
        <i class="fa fa-trash"></i> Delete
    </button>

</div>


<ng-template #deleteModal let-c="close" let-d="dismiss">
    Are you sure you want to delete this hotspot ?
</ng-template>


<ng-template #confirmMoveModal let-c="close" let-d="dismiss">
    Are you sure you want to move this hotspot ?
</ng-template>


<ng-template #editModal let-c="close" let-d="dismiss">
    <div class="form-group">
        <label for="hotspot-label">Enter a description for this hotspot</label>
        <input id="hotspot-label" autofocus type="text" [(ngModel)]="editModalLabel" class="form-control">
    </div>
    <div class="form-group">
        <label for="hotspot-type">Select the hotspot's type</label>
        <select id="hotspot-type" [(ngModel)]="editModalType" class="form-control">
            <option *ngFor="let type of hotspotsTypes" [value]="type">{{type | hotspotType}}</option>
        </select>
    </div>
</ng-template>
